/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ticketingSuccess.vue?vue&type=template&id=b2dc7824&scoped=true&"
import script from "./ticketingSuccess.vue?vue&type=script&lang=js&"
export * from "./ticketingSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ticketingSuccess.vue?vue&type=style&index=0&id=b2dc7824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dc7824",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
